import { jbColors } from 'theme/jbColors';
import palette from 'theme/palette';

const MuiAlert = {
  styleOverrides: {
    root: {
      whiteSpace: 'pre-line',
      fontSize: 12,
      lineHeight: '14px',
      borderRadius: '0',
      letterSpacing: 0,
      backgroundColor: jbColors.support.greenSmoke[10],
    },
    standardWarning: {
      backgroundColor: palette.warning.alertBg,
      color: palette.warning.alertColor,
      border: `1px solid ${palette.warning.alertColor}`,
    },
    standardInfo: {
      backgroundColor: palette.info.light,
      color: jbColors.technical.persianBlue[80],
      border: `1px solid ${palette.info.main}`,
      '& .MuiAlert-message': {
        margin: 'auto 0',
      },
    },
    standardError: {
      backgroundColor: jbColors.technical.carminRed[20],
      color: jbColors.technical.carminRed[80],
      border: `1px solid ${jbColors.technical.carminRed[80]}`,
      '& .MuiAlert-icon': {
        color: jbColors.technical.carminRed[80],
      },
    },
    standardSuccess: {
      // backgroundColor: jbColors.technical.forestGreen[40],
      backgroundColor: '#ecf5ec',
      color: jbColors.technical.forestGreen[80],
      border: `1px solid ${jbColors.technical.forestGreen[80]}`,
    },
    icon: {
      marginRight: 12,
      padding: '7px 4px',
      opacity: 1,
      alignItems: 'center',
      backgroundColor: 'transparent !important',
    },
    message: {
      padding: '10px 0',
      lineHeight: '16px',
    },
    action: {
      paddingLeft: 16,
      paddingRight: 20,
    },
  },
};

export default MuiAlert;
